export default __webpack_public_path__ + "static/apercu-regular-04fe22a3403033886d2fe0741e3fb88f.ttf";